import { setState } from '../core';
import { getLocalBookmarkEvents, isPageBookmarked } from '../helpers';

export const getDataForArticlePage = () => {
  // work with local data.
  const localList = getLocalBookmarkEvents();
  if (localList) {
    const bookmarked = isPageBookmarked(localList);
    setState({
      article: bookmarked ? 'bookmarked' : 'not-bookmarked',
    });
  } else {
    throw Error('no local List available');
  }
};

export const showModal = () => {
  setState({
    modalVisible: true,
  });
};
export const closeModal = () => {
  setState({
    modalVisible: false,
  });
};
